var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 15.5V4c0-.729-.29-1.429-.805-1.945A2.755 2.755 0 0 0 20 1.25H4c-.729 0-1.429.29-1.945.805A2.755 2.755 0 0 0 1.25 4v14c0 .729.29 1.429.805 1.945A2.755 2.755 0 0 0 4 20.75h8.5a.75.75 0 0 0 0-1.5H4A1.252 1.252 0 0 1 2.75 18V4A1.252 1.252 0 0 1 4 2.75h16A1.252 1.252 0 0 1 21.25 4v11.5a.75.75 0 0 0 1.5 0z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 7.75h20a.75.75 0 0 0 0-1.5H2a.75.75 0 0 0 0 1.5zM8.5 5.25h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5zM5 5.25h1a.75.75 0 0 0 0-1.5H5a.75.75 0 0 0 0 1.5zM22.062 22.08a2.348 2.348 0 0 0 0-3.321l-2.979-2.979a3.95 3.95 0 0 0-5.606-4.146.75.75 0 0 0-.207 1.207l1.679 1.679-.112.336-.335.111-1.679-1.679a.75.75 0 0 0-1.207.208 3.952 3.952 0 0 0 .771 4.493 3.941 3.941 0 0 0 3.375 1.112l2.978 2.98a2.349 2.349 0 0 0 3.322-.001zm-1.061-1.06a.85.85 0 0 1-1.2 0l-3.264-3.264a.75.75 0 0 0-.724-.194 2.448 2.448 0 0 1-3.079-2.242l1.035 1.036a.75.75 0 0 0 .768.181l1.13-.377c.224-.075.4-.25.475-.474l.376-1.131a.748.748 0 0 0-.181-.767l-1.034-1.035a2.44 2.44 0 0 1 1.607.713 2.45 2.45 0 0 1 .633 2.366.75.75 0 0 0 .194.723l3.264 3.264a.849.849 0 0 1 0 1.201z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAdmin);
export default __webpack_public_path__ + "static/media/sub-admin.c41b4f1ecddd3b9b5281d6d242159cb5.svg";
export { ForwardRef as ReactComponent };